module.exports = __webpack_public_path__ + "img/img-32.32d01dd5.png";